/**
 * Custom scripts for understrap child theme.
 */

import A11yBar from "./a11y-bar";

export {
    A11yBar
}
//import * as bootstrap from 'bootstrap';

/*
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})
*/

// Document ready
document.addEventListener("DOMContentLoaded", function() {
   
    // Gestoin des menus de 3 ème niveau
    document.querySelectorAll(".drilldown-menu > li > a").forEach(link => {
        link.addEventListener("click", function (e) {
        let submenu = this.nextElementSibling;
        if (submenu && submenu.classList.contains("submenu")) {
            e.preventDefault(); // Empêche la navigation immédiate

            // Ferme tous les autres sous-menus de 3ème niveau
            document.querySelectorAll(".drilldown-menu .submenu.show").forEach(openMenu => {
                if (openMenu !== submenu) {
                    openMenu.classList.remove("show");
                }
            });

            // Ouvre le sous-menu cliqué
            submenu.classList.add("show");

            // Crée un bouton retour
            if (!submenu.querySelector(".drilldown-back")) {
            let backButtonLi = document.createElement("li");
            let backButton = document.createElement("button");
            backButton.className = "drilldown-back custom--icon svg--arrow";

            // Ajoute le texte accessible dans un <span>
            /*let hiddenText = document.createElement("span");
            hiddenText.className = "visually-hidden";
            hiddenText.innerText = "Retour vers ";*/

            // backButton.appendChild(hiddenText); // Ajoute "Retour vers"
            backButton.appendChild(document.createTextNode("Retour")); // Ajoute le nom du menu

            // Ajoute le bouton juste avant le sous-menu (dans le <li> parent)
            backButtonLi.appendChild(backButton);
            submenu.prepend(backButtonLi);

            backButton.addEventListener("click", function () {
                submenu.classList.remove("show");
            });
            
            }
        }
        });
    });

    // Empêche le menu de se refermer au clic
    document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
        menu.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        // Gère l'événement keydown pour le menu
        menu.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                // Cache le menu
                menu.classList.remove('show');

                // Met le focus sur le lien adjacent
                const siblingLink = menu.previousElementSibling;
                if (siblingLink && siblingLink.tagName === 'A') {
                    siblingLink.focus();
                }
            }
        });
    });

    // Changement du comportement du bouton de recherche pour la home page
    const homeContainer = document.querySelector('.home');
    if (homeContainer) {
        const searchButton = homeContainer.querySelector('#search-form--button');
        if (searchButton) {
            searchButton.addEventListener('click', function(event) {
                // Action de retour en haut de la page
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Pour un défilement fluide
                });
                // Attendre un peu pour que le scroll fluide ait lieu, puis focus sans scroll
                setTimeout(() => {
                    const searchInput = document.getElementById('s-1');
                    if (searchInput) {
                        searchInput.focus({ preventScroll: true });
                    }
                }, 500); // ajuste la durée si besoin
                console.log('Retour en haut de la page et focus !');
            });
        }
    }

    // Prise du focus au clic de la recherche
    if(document.getElementById("search-form--collapse")) {
        document.getElementById('search-form--collapse').addEventListener('shown.bs.collapse', function() {
            document.getElementById('s-1').focus();
        });
    }

    // Focus on first element with social sharing button
    if(document.getElementById("share--collapse")) {
        document.getElementById("share--collapse").addEventListener("shown.bs.dropdown", function () {
            document.querySelector("#share--collapse .menu--social .icon-menu").children[0].focus();
        });
    }

    // Social Sharing Copy URL Button
    if(document.getElementById("dropdownShareButton")) initBtnCopyUrl();

    // -- DEBUT -- Survol carte territoires
    if(document.querySelectorAll('.territory--badge')) {
    document.querySelectorAll('.territory--badge').forEach(link => {
        
        link.addEventListener('mouseenter', () => {
            
        const classes = Array.from(link.classList);
        
        const territoryClass = classes.find(c => c.startsWith('territory-') && c !== 'territory--badge');
        if (territoryClass) {
            const id = territoryClass.replace('territory-', '');
            const svgElement = document.getElementById(id);
            if (svgElement) {
            svgElement.classList.add('hover');
            }
        }
        });

        link.addEventListener('mouseleave', () => {
        const classes = Array.from(link.classList);
        const territoryClass = classes.find(c => c.startsWith('territory-') && c !== 'territory--badge');
        if (territoryClass) {
            const id = territoryClass.replace('territory-', '');
            const svgElement = document.getElementById(id);
            if (svgElement) {
            svgElement.classList.remove('hover');
            }
        }
        });
    });
    }
    // -- FIN -- Survol carte territoires

    // Affichage du bouton de retour en haut de page
	var btnTop = document.getElementById('btn-to-top');
	window.addEventListener('scroll', function() {
        // Vérifier si la position de défilement vertical est supérieure à 300 pixels
        if (window.scrollY > 300) {
            // Ajouter la classe 'show' au bouton
            btnTop.classList.add('show');
        } else {
            // Retirer la classe 'show' du bouton
            btnTop.classList.remove('show');
        }
    });

    // -- DEBUT -- Construction automatique du sommaire sur la partie Gutenberg
    if(document.querySelector(".entry-content") && (document.querySelector(".check-summary") || document.getElementById("summary"))) {
        
        const content = document.querySelector(".entry-content");
        const headings = content.querySelectorAll("h2:not(.screen-reader-text)");
        const listItems = [];

        headings.forEach((heading) => {
            
            let text = "";
            // Si le titre contient uniquement du texte :
            if (heading.childNodes.length === 1 && heading.childNodes[0].nodeType === Node.TEXT_NODE) {
                text = heading.textContent.trim();
            } else {
                // Cas où il y a plusieurs enfants (accodéon), je ne prends que le texte du bouton
                text = heading.querySelector("button").textContent.trim();
            }

            let id = text.toLowerCase()
                .normalize("NFD") // décompose les caractères accentués
                .replace(/[\u0300-\u036f]/g, "") // supprime les accents
                .replace(/['’"]/g, "") // supprime les apostrophes et guillemets
                .replace(/[^\w\s-]/g, "") // supprime toute autre ponctuation
                .trim()
                .replace(/\s+/g, "-"); // remplace les espaces par des tirets

            if (/^\d/.test(id)) {
                id = "section-" + id;
            }
            
            heading.setAttribute("id", id);

            const listItem = document.createElement("li");
            const link = document.createElement("a");
            link.setAttribute("href", `#${id}`);
            link.textContent = text;
            listItem.appendChild(link);
            listItems.push(listItem);
            
        });

        let toc = document.getElementById("summary");

        if (listItems.length > 0) {
            if (!toc) {
                //alert("pas de sommaire");
                // Création du sommaire complet avec la colonne de mise en page
                const summaryCol = document.createElement("div");
                summaryCol.className = "col-12 col-sm-10 col-md-8 col-lg-3 col-xl-3 d-none d-lg-block";

                const summaryBox = document.createElement("div");
                summaryBox.className = "summary sticky-top";

                const heading = document.createElement("h2");
                heading.className = "visually-hidden";
                heading.textContent = "Sommaire"; // Pour la traduction PHP, elle est faite côté serveur

                toc = document.createElement("ol");
                toc.id = "summary";

                summaryBox.appendChild(heading);
                summaryBox.appendChild(toc);
                summaryCol.appendChild(summaryBox);

                // Insertion dans la .row, avant la col-lg-8
                const colContent = content.closest(".check-summary");
                const row = colContent?.parentElement;
                if (row && colContent) {
                    row.insertBefore(summaryCol, colContent);
                }
            }
            toc.prepend(...listItems);
            
        }
    }
    // -- FIN -- Construction automatique du sommaire sur la partie Gutenberg


    // -- DEBUT -- Mémorisation de la fermeture de la zone d'alerte générale
    const alertId = "global-alert";
    const alertElement = document.getElementById(alertId);

    if (alertElement) {

        if (sessionStorage.getItem(alertId + "-dismissed") === "true") {
            // Ne rien faire, l'alerte reste masquée (d-none déjà présente)
        } else {
            // Affiche l'alerte en retirant la classe d-none
            alertElement.classList.remove("d-none");

            alertElement.addEventListener("closed.bs.alert", function () {
                sessionStorage.setItem(alertId + "-dismissed", "true");
            });
        }

    }
    // -- FIN -- Mémorisation de la fermeture de la zone d'alerte générale


    // Prise du focus sur le nombre de résultats en cas de recherche par filtre
    var element = document.getElementById('result-number');
    var filtersForm = document.querySelector('form.filters-form');
    if (element && filtersForm ) {
        var filterWithValue = filtersForm.querySelector('.filter.has-value');
        if (filterWithValue) {
            element.focus();
        }
    }
    
});

/**
 * Create a copy feature for all elements with class name 'btn-copy-url'
 * @todo create a param to change class name selector
 */
function initBtnCopyUrl() {

	let hideFeature = false;
	if(!navigator.clipboard){
		console.error("Clipboard not available for this browser. Copy URL feature aborted.");
		hideFeature = true;
	}

	if(!window.isSecureContext) {
		console.error("You're not in a secure context. Clipboard API is disabled. Copy URL feature aborted.");
		hideFeature = true;
	}

	const btnCopyCollection = document.getElementsByClassName('btn-copy-url');

	if(hideFeature) {
		for(let btnCopy of btnCopyCollection) {
			let parentElement = btnCopy.closest('li');
			parentElement.style.display = 'none';
		}
		return;
	}

	for(let btnCopy of btnCopyCollection) {
		btnCopy.addEventListener('click', function (event) {
			let currentElement = event.currentTarget;
			let currentURL = currentElement.getAttribute('data-clipboard') || window.location.href;
			// TODO : use wp-i18n methods here if need multilingual
			let copiedMsg = currentElement.getAttribute('data-clipboard-msg') || 'Lien copié';

			// copy in navigator.clipboard (not available with IE)
			navigator.clipboard.writeText(currentURL);

			currentElement.lastElementChild.textContent =  copiedMsg;
			currentElement.classList.add( 'copied' );

			let timer = setInterval( function(){
				currentElement.classList.remove( 'copied' );
				clearInterval(timer);
			}, 36000 );
		})
	}
}


